import React from 'react';
import {useTranslation} from 'react-i18next';

import saveAs from 'file-saver';

import {showNewNotification} from '@edna/components';

import {useLazyGetFileQuery} from './api';

const useDownloadFile = () => {
  const [getFile] = useLazyGetFileQuery();
  const {t} = useTranslation();

  const downloadFile = React.useCallback(
    async (id: string, fileName?: string, onError?: (error: unknown) => void) => {
      try {
        const file = await getFile({id, fileName, skipError: !!onError}).unwrap();

        saveAs(file);

        showNewNotification({
          type: 'SUCCESS',
          message: t('Common:successDownload'),
        });
      } catch (error) {
        onError?.(error);
      }
    },
    [getFile, t],
  );

  return downloadFile;
};

export {useDownloadFile};
